"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEEP = exports.RIDE_THROUGH = exports.REAFFIRM = exports.REDEEM = exports.SURRENDER = void 0;
exports.SURRENDER = "surrender";
exports.REDEEM = "redeem";
exports.REAFFIRM = "reaffirm";
exports.RIDE_THROUGH = "rideThrough";
exports.KEEP = "keep";